//type BrushWidthRange = 4 | 8 | 12;

export enum BrushWidthRange{LEVEL1=4, LEVEL2=8, LEVEL3=12};

export interface IDrawState {
  brushWidth: BrushWidthRange;
  brushColor: string;
}

